import { Component, OnInit, Input, SimpleChanges } from '@angular/core';

import { DemoozColor, DemoozColorPrimary } from '@demooz/types';

@Component({
  selector: 'demooz-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
})
export class DemoozProgressBarComponent  implements OnInit {
    
    @Input({alias : 'value', required : true}) valueProgressBar: number = 0;
    @Input({alias : 'max', required : false}) maxProgressBar: number;
    @Input({alias : 'color', required : false}) colorProgressBar: DemoozColor = DemoozColorPrimary;
    @Input({alias : 'size', required : false}) sizeProgressBar: 'normal'|'small'|'very-small' = 'normal';
    @Input({alias : 'showSepValue', required : false}) showSepValue: boolean = true;
    @Input({alias : 'showValue', required : false}) showValue: boolean = true;
    @Input({alias : 'showPourcent', required : false}) showPourcent: boolean = true;
    @Input({alias : 'showMax', required : false}) showMax: boolean = false;
    @Input({alias : 'withMargin', required : false}) withMargin: boolean = true;

    pourcent: number = 0;

    constructor() { }

    ngOnInit() {
        
    }
    
    async ngOnChanges(changes: SimpleChanges) {        
        if(changes['valueProgressBar'] || changes['maxProgressBar']){
            this.pourcent = this.getPourcent();
        }
    }

    getPourcent(): number{
        if(typeof this.maxProgressBar !== 'undefined'){
            return Math.round((this.maxProgressBar > 0 && 0 <= this.valueProgressBar && this.valueProgressBar <= this.maxProgressBar ? this.valueProgressBar / this.maxProgressBar : (this.valueProgressBar > this.maxProgressBar ? this.maxProgressBar : 0)) * 100);
        }
        else{
            return Math.round(this.valueProgressBar > 100 ? 100: this.valueProgressBar);
        }
    }
    
}
